import { useMutation, useQueryClient } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest } from '../utils/graphqlClient';

const sendTripManagementInvitation = graphql(/* GraphQL */ `
  mutation sendTripManagementInvitation(
    $bookingId: Int!
    $userId: String!
    $guestNumber: Int!
    $guestEmail: String!
  ) {
    tripInvite(
      bookingId: $bookingId
      userId: $userId
      guestNumber: $guestNumber
      guestEmail: $guestEmail
    )
  }
`);

export const useSendTripInvitation = () => {
  const queryClient = useQueryClient();
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  return useMutation({
    mutationFn: async ({
      bookingId,
      userId,
      guestNumber,
      guestEmail,
    }: {
      bookingId: number;
      userId: string;
      guestNumber: number;
      guestEmail: string;
      tripId: number;
    }) => {
      if (!isAuthenticated) {
        throw new Error('User must be authenticated to send trip invitation');
      }
      return graphqlRequest(
        sendTripManagementInvitation,
        {
          bookingId,
          userId,
          guestNumber,
          guestEmail,
        },
        getAccessTokenSilently,
      );
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['tripInvites'] });
    },
    onError: (error: Error) => {
      console.error('Failed to send trip invitation:', error);
    },
  });
};
